import { Col, Form, Input, Row } from 'antd'
import * as convertUnits from 'convert-units'
import FormSectionTitle from '../elements/FormSectionTitle'
import withSpinning from '../elements/HOC/withSpinning'
import withSelectFetch from '../elements/Select/withSelectFetch'
import { get, round } from 'lodash'
import { defaultFormItemLayout, threeFormItemLayout } from '../modules/FormItems'
import React, { Fragment, useEffect } from 'react'
import { compose } from 'recompose'
import withSort from './HOC/withSort'
import InfoTooltip from './InfoTooltip'
import Country from './Select/Country'
import CustomSelect from './Select/CustomSelect'
import withData from './Select/withData'

const { TextArea } = Input

function ShippingDetails(props) {
  const { getFieldDecorator, getFieldValue, setFieldsValue, resetFields, line, type } = props

  const isCargo = type === 'cargo'
  const ScaleMap = {
    mm: 'mm3',
    cm: 'cm3',
    m: 'm3',
    in: 'in3',
    ft: 'ft3',
    km: 'km3',
  }
  const length = getFieldValue('shipping.dimensions.length') || 0
  const width = getFieldValue('shipping.dimensions.width') || 0
  const height = getFieldValue('shipping.dimensions.height') || 0
  const dimensionScale = getFieldValue('shipping.dimensions.scale.code')
  const volumeScale = getFieldValue('shipping.volume.scale.code')
  const attrMap = dimensionScale ? ScaleMap[dimensionScale] : ''

  useEffect(() => {
    if (!!length && !!width && !!height && !!dimensionScale) {
      const volume = length * width * height

      const converted = convertUnits(volume).from(attrMap).to(volumeScale)
      setFieldsValue({ 'shipping.volume.volume': converted })
    }
  }, [length, width, height, attrMap, volumeScale])

  return (
    <Fragment>
      <FormSectionTitle title={'WEIGHTS & DIMENSIONS'} />
      <Row>
        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Length Scale">
            {getFieldDecorator('shipping.dimensions.scale.code', {
              initialValue: get(line, 'shipping.dimensions.scale.code') || 'mm',
            })(<LengthUOM />)}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Length">
            {getFieldDecorator('shipping.dimensions.length', {
              initialValue: get(line, 'shipping.dimensions.length'),
            })(
              <Input
                style={{ width: '100%' }}
                placeholder={'Shipping Length'}
                addonAfter={getFieldValue('shipping.dimensions.scale.code')}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Width">
            {getFieldDecorator('shipping.dimensions.width', {
              initialValue: get(line, 'shipping.dimensions.width'),
            })(
              <Input
                style={{ width: '100%' }}
                placeholder={'Shipping Width'}
                addonAfter={getFieldValue('shipping.dimensions.scale.code')}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Height">
            {getFieldDecorator('shipping.dimensions.height', {
              initialValue: get(line, 'shipping.dimensions.height'),
            })(
              <Input
                style={{ width: '100%' }}
                placeholder={'Shipping Height'}
                addonAfter={getFieldValue('shipping.dimensions.scale.code')}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Weight Scale">
            {getFieldDecorator('shipping.weights.scale.code', {
              initialValue: get(line, 'shipping.weights.scale.code') || 'kg',
            })(<MassUOM />)}
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Net Weight">
            {getFieldDecorator('shipping.weights.net', {
              initialValue: get(line, 'shipping.weights.net'),
            })(<Input placeholder={'Shipping Net Weight'} addonAfter={getFieldValue('shipping.weights.scale.code')} />)}
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Gross Weight">
            {getFieldDecorator('shipping.weights.gross', {
              initialValue: get(line, 'shipping.weights.gross'),
            })(
              <Input placeholder={'Shipping Gross Weight'} addonAfter={getFieldValue('shipping.weights.scale.code')} />
            )}
          </Form.Item>
        </Col>

        <Col span={6}>
          <Form.Item {...threeFormItemLayout} label="Volume Scale">
            {getFieldDecorator('shipping.volume.scale.code', {
              initialValue: get(line, 'shipping.volume.scale.code') || 'm3',
            })(<VolumeUOM />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...threeFormItemLayout} label="Volume">
            {getFieldDecorator('shipping.volume.volume', {
              initialValue: get(line, 'shipping.volume.volume'),
            })(
              <Input
                disabled={true}
                placeholder={'Shipping volume'}
                addonAfter={getFieldValue('shipping.volume.scale.code')}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label="Stackable">
            {getFieldDecorator('shipping.stackable', {
              initialValue: get(line, 'shipping.stackable'),
            })(<Stackable />)}
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item {...defaultFormItemLayout} label={<InfoTooltip value={'CoO'} title={'Country of Origin'} />}>
            {getFieldDecorator('shipping.country.origin', {
              initialValue: get(line, 'shipping.country.origin'),
            })(<Country placeholder={'Country of Origin'} />)}
          </Form.Item>
        </Col>

        {isCargo && (
          <Col span={8}>
            <Form.Item
              {...defaultFormItemLayout}
              label={<InfoTooltip value={'CoD'} title={'Country of Destination'} />}>
              {getFieldDecorator('shipping.country.destination', {
                initialValue: get(line, 'shipping.country.destination'),
              })(<Country placeholder={'Country of Destination'} />)}
            </Form.Item>
          </Col>
        )}

        {!isCargo && (
          <Col span={8}>
            <Form.Item {...defaultFormItemLayout} label="HS Code">
              {getFieldDecorator('shipping.hsCode', {
                initialValue: get(line, 'shipping.hsCode'),
              })(<Input placeholder={'HS Code'} />)}
            </Form.Item>
          </Col>
        )}
      </Row>
    </Fragment>
  )
}

export default ShippingDetails

const Stackable = compose(
  withData({
    data: [
      { key: 'Yes', value: 'Yes' },
      { key: 'No', value: 'No' },
    ],
  }),
  withSort
)(CustomSelect)

const LengthUOM = compose(
  withSelectFetch({ dropdown: 'general', name: 'length' }),
  withSpinning,
  withSort
)(CustomSelect)
const MassUOM = compose(withSelectFetch({ dropdown: 'general', name: 'mass' }), withSpinning, withSort)(CustomSelect)

const VolumeUOM = compose(
  withSelectFetch({ dropdown: 'general', name: 'volume' }),
  withSpinning,
  withSort
)(CustomSelect)
